import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Clock, LogOut } from "lucide-react";

interface SessionTimeoutDialogProps {
  open: boolean;
  remainingSeconds: number;
  onExtend: () => void;
  onLogout: () => void;
}

function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export function SessionTimeoutDialog({
  open,
  remainingSeconds,
  onExtend,
  onLogout,
}: SessionTimeoutDialogProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-warning/10">
              <Clock className="h-6 w-6 text-warning" />
            </div>
            <div>
              <AlertDialogTitle>Istuntosi on vanhentumassa</AlertDialogTitle>
              <AlertDialogDescription className="mt-1">
                Sinut kirjataan ulos turvallisuussyistä, ellei jatka istuntoa.
              </AlertDialogDescription>
            </div>
          </div>
        </AlertDialogHeader>
        
        <div className="my-4 flex items-center justify-center">
          <div className="text-center">
            <div className="text-4xl font-bold text-foreground tabular-nums">
              {formatTime(remainingSeconds)}
            </div>
            <div className="text-sm text-muted-foreground mt-1">
              aikaa jäljellä
            </div>
          </div>
        </div>

        <AlertDialogFooter className="flex-col gap-2 sm:flex-row">
          <Button
            variant="outline"
            onClick={onLogout}
            className="w-full sm:w-auto"
          >
            <LogOut className="mr-2 h-4 w-4" />
            Kirjaudu ulos
          </Button>
          <Button
            onClick={onExtend}
            className="w-full sm:w-auto"
          >
            Jatka istuntoa
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
